import type { ReactNode } from 'react'
import React from 'react'
import { Box } from '@mui/material'
import StatisticsCard from '@app/src/pages/Dashboards/StatisticsCard'

interface CompanyPageSectionProps {
  title: string
  children: ReactNode
}

export const CompanyPageSection = ({ title, children }: CompanyPageSectionProps) => {
  return (
    <StatisticsCard title={title} sx={{ height: 'auto' }}>
      <Box width="100%" pt={1.5} pb={1}>
        {children}
      </Box>
    </StatisticsCard>
  )
}
